export default "__VITE_ASSET__8bf496d6__"